import { useSelector } from 'react-redux'

const useAppSelector = selector => useSelector(selector)

export default useAppSelector
